<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               :title="title" size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">
          <el-form-item label="驳回备注" v-if="commentDrawTitle==='可换机型驳回'">
            <el-input type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      v-model="formData.rejectSelectItemRemark"
                      autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="驳回备注" v-if="commentDrawTitle==='创建销售发货订单驳回'">
            <el-input type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      v-model="formData.rejectCreateSalesOrderRemark"
                      autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="审批备注" v-if="commentDrawTitle==='总部服务支持经理审批'">
            <el-input type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      v-model="formData.serviceSupportManagerRemark"
                      autocomplete="off"
            ></el-input>
          </el-form-item>
            <el-form-item label="结算方式" :rules="{required: true}" v-if ="commentDrawTitle==='确认结算方式'">
              <dict-select dict-type="结算方式"
                           :dict-item-name.sync="formData.settleTypeName"
                           :dict-item-id.sync="formData.settleTypeId"/>
            </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="doCommit">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
// import orderPop from './orderDialog.vue'

import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";

export default {
  components: {DictSelect},
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'exchangeOrderId', 'commentDrawTitle', 'rejectType'],
  created() {
    if (this.commentDrawTitle){
      if (this.commentDrawTitle.includes('驳回')){
        this.title = '驳回'
      }else{
        this.title = this.commentDrawTitle
      }
      if (this.title === '驳回'){
        this.url = api.wkExchangeOrder.rejectDataUrl
      }
      if (this.commentDrawTitle==='总部服务支持经理审批'){
        this.url = api.wkExchangeOrder.serviceSupportManagerCheckUrl
      }
      if (this.commentDrawTitle ==='确认结算方式'){
        this.url = api.wkExchangeOrder.commitSettleTypeUrl
      }

    }
    this.formData.exchangeOrderId = this.exchangeOrderId
    this.formData.rejectType = this.rejectType
  },
  data() {
    return {
      url :null,
      title:null,
      formData: {
        id: null,
        rejectType: null,
        rejectSelectItemRemark:null,
        rejectCreateSalesOrderRemark:null,
        serviceSupportManagerRemark:null,
        settleTypeId:null,
        settleTypeName:null
      },
      drawer: true,
    }
  },
  methods: {
    // 关闭
    doCommit() {
      if (this.commentDrawTitle === '可换机型驳回' && !this.formData.rejectSelectItemRemark){
        this.$message.error("请输入驳回备注")
        return
      }
      if (this.commentDrawTitle === '创建销售发货订单驳回' && !this.formData.rejectCreateSalesOrderRemark){
        this.$message.error("请输入驳回备注")
        return
      }
      if (this.commentDrawTitle === '总部服务支持经理审批' && !this.formData.serviceSupportManagerRemark){
        this.$message.error("请输入审批备注")
        return
      }
      if (this.commentDrawTitle === '确认结算方式' && !this.formData.settleTypeId){
        this.$message.error("请选择结算方式")
        return
      }
      this.$http({
        url: this.url,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('操作成功')
        this.$emit('closeDraw',true)
      }).catch(() => {
        this.$message.error("操作失败！");
        this.$mask.close()
      });
    },




    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
      this.handleClose()
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeDraw', false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
